import css from 'styled-jsx/css'

const staticStyles = css`
  .BigChart__inner {
    min-height: 290px !important;
  }
`

export { staticStyles }
